import { API, getClientId } from "@/lib/api";

export async function streamGeneration({ tool, model, fields, email, onStart, onDelta }) {
  const res = await fetch(`${API}/tools/generate`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ tool, model, fields, email, client_id: getClientId() }),
  });
  if (res.status === 403) return { gated: true };
  if (!res.ok) throw new Error("No se pudo generar el contenido.");
  onStart();
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const parts = buffer.split("\n\n");
    buffer = parts.pop();
    for (const p of parts) {
      if (!p.startsWith("data: ")) continue;
      const msg = JSON.parse(p.slice(6));
      if (msg.error) throw new Error(msg.error);
      if (msg.delta) onDelta(msg.delta);
    }
  }
  return { gated: false };
}
